/** काम का इंतज़ाम (ADR 0046): घंटे के हिसाब से, एक बार, हफ़्ते में कुछ दिन, या महीने के हिसाब से। */
export const arrangement = {
    "question.arrangement": "काम कितने समय के लिए है?",
    "detail.arrangement": "कितने समय के लिए",
    "arrangement.hourly": "घंटे के हिसाब से",
    "arrangement.visit": "एक बार",
    "arrangement.weekly": "हफ़्ते में कुछ दिन",
    "arrangement.monthly": "महीने के हिसाब से",
    "unit.hour": "प्रति घंटा",
    "unit.visit": "प्रति बार",
    "unit.week": "प्रति हफ़्ता",
    "unit.month": "प्रति महीना",
    "price.per": "{price} {unit}",
    "estimate.range_week": "{city} में {trade}{scope}: आम तौर पर एक हफ़्ते का {low}–{high}।",
    "need.ask.arrangement": "आपको कितने समय के लिए चाहिए?",
    "need.arr.hourly": "कुछ घंटे",
    "need.arr.visit": "सिर्फ़ एक बार",
    "need.arr.weekly": "हफ़्ते में कुछ दिन",
    "need.arr.monthly": "हर महीने",
    "need.arr.meal": "एक वक़्त का खाना या कोई मौका",
    "need.field_arrangement": "कितने समय के लिए",
    "need.summary_arrangement": "काम: {arrangement}।",
    "need.budget_per.hour": "यह एक घंटे के लिए ज़्यादा से ज़्यादा है।",
    "need.budget_per.visit": "यह उस एक बार के लिए ज़्यादा से ज़्यादा है।",
    "need.budget_per.week": "यह एक हफ़्ते के लिए ज़्यादा से ज़्यादा है।",
    "need.budget_per.month": "यह एक महीने के लिए ज़्यादा से ज़्यादा है।",
    "iv.ask.arrangements": "आप किस तरह का काम लेते हैं? हर एक पर टैप करें, फिर हो गया दबाएँ।",
    "iv.done": "हो गया",
    "iv.err_arrangements": "कम से कम एक तरह का काम चुनें।",
    "iv.picked": "आप काम लेते हैं: {list}।",
    "iv.ask.rate_hour": "एक घंटे का कितना लेते हैं?",
    "iv.ask.rate_week": "एक हफ़्ते का कितना लेते हैं?",
    "iv.summary_rate": "{arrangement}: {rate}।",
    "card.arrangements": "मैं कौन सा काम लेता/लेती हूँ",
    "card.rate.hourly": "एक घंटे का दाम, ₹",
    "card.rate.visit": "एक बार का दाम, ₹",
    "card.rate.weekly": "एक हफ़्ते का दाम, ₹",
    "card.rate.monthly": "एक महीने का दाम, ₹",
    "card.err_arrangements": "कम से कम एक तरह का काम चुनें, हर एक का दाम लिखें।",
    "card.radius": "मैं कितनी दूर तक जाता/जाती हूँ",
    "card.km": "{km} किमी",
};
//# sourceMappingURL=arrangement.js.map